export default __webpack_public_path__ + "static/img01-42212d218a3405b5d946e61e3a82d719.png";